import { createAsyncThunk } from '@reduxjs/toolkit';

import { driverAPI } from '@/modules/driver/api';
import { IDriver } from '@/modules/driver/model/driver';
import { namespace } from '@/modules/driver/namespace';

import { setDriver } from '../actions';

const loadDriverById = createAsyncThunk(
  `${namespace}/load-driver-by-id`,
  async (id: string | undefined, { dispatch }): Promise<IDriver | undefined> => {
    if (id === undefined) {
      return undefined;
    }

    const driver = await driverAPI.fetchDriverById(id);

    dispatch(setDriver(driver));

    return driver;
  },
);

export { loadDriverById };
